// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { propType } from 'graphql-anywhere';
// ANTD
import notification from 'antd/lib/notification';
// APOLLO
import { graphql } from 'react-apollo';
import sessionFragment from 'ApolloClient/Fragments/sessionFragment';
import SAVE_SESSION from 'ApolloClient/Mutations/saveSession';
import GET_SESSIONS_BY_CLIENT_ID from 'ApolloClient/Queries/sessionsByClientId';
import GET_SESSIONS from 'ApolloClient/Queries/sessions';
import GET_CLIENT_BY_ID from 'ApolloClient/Queries/clientById';
// COMPONENTS
import SessionForm from 'components/forms/SessionFormLegacy';

export class SaveCalendarSession extends React.Component {
  state = {
    disabled: false, // whether or not the form submit button is disabled
  };

  disableBtn = () => {
    this.setState({ disabled: true });
  };

  enableBtn = () => {
    this.setState({ disabled: false });
  };

  handleCancel = () => {
    const { onCancel } = this.props;
    this.enableBtn();
    // Pass event up to parent component
    onCancel();
  };

  handleSubmit = async editSession => {
    const { session, saveSession, onComplete } = this.props;

    this.disableBtn();

    const variables = { _id: session._id, params: editSession };
    const refetchQueries = [{ query: GET_SESSIONS }];
    // Refetch both the old client sessions (in case client changed) and the new
    // client's sessions
    if (editSession.clientId) {
      refetchQueries.push({
        query: GET_SESSIONS_BY_CLIENT_ID,
        variables: { _id: editSession.clientId },
      });
      refetchQueries.push({
        query: GET_CLIENT_BY_ID,
        variables: { _id: editSession.clientId },
      });
    }
    if (session.client && session.client._id) {
      refetchQueries.push({
        query: GET_SESSIONS_BY_CLIENT_ID,
        variables: { _id: session.client._id },
      });
      refetchQueries.push({
        query: GET_CLIENT_BY_ID,
        variables: { _id: session.client._id },
      });
    }

    try {
      await saveSession({ variables, refetchQueries });
      notification.success({ message: 'Session successfully saved!' });
      // Pass event up to parent component
      onComplete();
    } catch (exc) {
      console.log(exc.message);
      // notification.error({ message: exc });
      notification.error({ message: exc.message });
    }

    this.enableBtn();
  };

  render() {
    const { disabled, session, hideClientInput } = this.props;

    return (
      <SessionForm
        // type="edit"
        btnLabel={!disabled ? 'Save' : 'Saving...'}
        initialValue={session}
        hideClientInput={hideClientInput}
        disabled={disabled}
        sessionTypes={this.props.sessionTypes}
        onBeforeHook={this.disableBtn}
        onErrorHook={this.enableBtn}
        onSubmitHook={this.handleSubmit}
        onCancel={this.enableBtn}
      />
    );
  }
}

SaveCalendarSession.propTypes = {
  session: propType(sessionFragment).isRequired,
  onComplete: PropTypes.func,
  onCancel: PropTypes.func,
  hideClientInput: PropTypes.bool,
};

SaveCalendarSession.defaultProps = {
  // session: null,
  onComplete: () => {},
  onCancel: () => {},
  hideClientInput: false,
};

const withMutation = graphql(SAVE_SESSION, { name: 'saveSession' });

export default withMutation(SaveCalendarSession);



// WEBPACK FOOTER //
// ./src/components/common/SaveCalendarSession/index.js